import Reveal from "@/components/base/Reveal";
import { clinic } from "@/data/clinic";

export default function ContactInfo() {
  const details = [
    {
      icon: "ri-user-star-line",
      label: "Practice Owner",
      value: clinic.owner,
      href: undefined,
    },
    {
      icon: "ri-phone-line",
      label: "Phone",
      value: clinic.phone,
      href: clinic.phoneHref,
    },
    {
      icon: "ri-mail-line",
      label: "Email",
      value: clinic.email,
      href: `mailto:${clinic.email}`,
    },
    {
      icon: "ri-map-pin-line",
      label: "Address",
      value: clinic.addressFull,
      href: undefined,
    },
  ];

  return (
    <section className="w-full bg-background-50 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-5">
          <div className="rounded-xl border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              {clinic.brand}
            </h2>
            <p className="mt-2 text-sm font-semibold tracking-[0.12em] uppercase text-primary-600">
              {clinic.legalName}
            </p>

            <ul className="mt-8 space-y-6">
              {details.map((detail) => (
                <li key={detail.label} className="flex items-start gap-4">
                  <span className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0">
                    <i className={`${detail.icon} text-xl text-secondary-700`} />
                  </span>
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.12em] text-foreground-500">
                      {detail.label}
                    </p>
                    {detail.href ? (
                      <a
                        href={detail.href}
                        className="mt-1 block text-base font-medium text-foreground-900 transition-colors duration-200 hover:text-primary-700 cursor-pointer break-words"
                      >
                        {detail.value}
                      </a>
                    ) : (
                      <p className="mt-1 text-base font-medium text-foreground-900">
                        {detail.value}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
              <a
                href={clinic.phoneHref}
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-primary-600"
              >
                <i className="ri-phone-line" />
                Call the Clinic
              </a>
              <a
                href={`mailto:${clinic.email}`}
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-accent-600"
              >
                <i className="ri-mail-line" />
                Email the Clinic
              </a>
              <a
                href={clinic.directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md border border-background-300 bg-background-50 text-foreground-900 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-navigation-line" />
                Get Directions
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={120}>
          <div className="h-full rounded-xl border border-background-200 overflow-hidden bg-background-100">
            <iframe
              title="Map showing Florida Family Clinic at 1800 SW 27th Avenue, Miami, FL 33145"
              src={clinic.mapEmbed}
              className="w-full h-[320px] md:h-full min-h-[420px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}